import React from 'react';

import CurrentGroupCard from './components/CurrentGroupCard';
import CurrentGroupChildren from './components/CurrentGroupChildren';
import { Container } from './styles';

const CurrentGroup: React.FC = () => {
  return (
    <Container>
      <CurrentGroupCard />
      <CurrentGroupChildren />
    </Container>
  );
};

export default CurrentGroup;
